exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".quote-container {\n  color: var(--blue);\n}\n\n.quote-block-top {\n  margin-bottom: 50px;\n}\n\n.carousel-slide {\n  height: 100%;\n  background-color: white;\n  text-align: left;\n  padding: 0px 2px;\n}\n", ""]);

// exports
